import { ISitrepProposal, IProposalsForEvent, ProposalListPartitioned } from "./interfaces";

export function partitionRows(proposals: ISitrepProposal[]): ProposalListPartitioned {
    const result: ProposalListPartitioned = Object.values(proposals.reduce((acc, proposal) => {
        let a: IProposalsForEvent = acc[proposal.masterEventId];
        if (!a) {
            a = acc[proposal.masterEventId] = {
                eventName: `${ proposal.eventName } ${ proposal.eventLocation }`,
                eventId: proposal.masterEventId,
                proposals: [],
            };
        }
        a.proposals.push(proposal);
        return acc;
    }, {}));
    return result.sort((obj1, obj2) => {
        if (obj1.eventName < obj2.eventName) { return -1; }
        if (obj1.eventName > obj2.eventName) { return 1; }
        return 0;
    });
}


const baseUrl = "/backend/toolbox/sitrepadmin";

export async function apiPost<T = void>(service: string, params = {}): Promise<T> {
    const url = `${ baseUrl }${ service }`;
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
            "Content-type": "application/json",
        },
    });
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response.json();
}

export async function apiGet<T = void>(service: string): Promise<T> {
    const url = `${ baseUrl }${ service }`;
    const response = await fetch(url);
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response.json();
}
